import type { StudioOption } from 'src/components/star-grid/reportStudio.types';
export const studioSelectOptions = (options: readonly StudioOption[]) => options.map((option) => ({ value: option.id, label: option.label }));
export const studioSelectedOption = (options: readonly StudioOption[], value: string) => ({
  value,
  label: options.find((option) => option.id === value)?.label ?? (value || '—')
});
